<template>

<div class="modal-mask-pause background-dance">
  <div class="modal-wrapper-pause">
    <div class="modal-container-pause">
      <div class="close tamanhoicon" @click="$emit('closeModal')">
          <img :src="require('@/assets/buttons/newbuttons/dance/close.svg')" />
      </div>
      <div class="modal-header-pause tamanhotitle">
        <slot name="header">
          {{$t('menu.settings.sound')}}
        </slot>
      </div>
      <div class="modal-body-pause">
          <slot name="body">
            <label class="switch">
              <input type="checkbox" />
              <span class="slider round"></span>
            </label> 
          </slot>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
    name: "SettingsGame",
    emits: ['closeModal'],
    created() {},
    data() {
        return {};
    },
    props: {},
    methods: {},
};
</script>

<style>
</style>
